import { post, get, downloadFile } from './Tools';

const procesarPreNomina = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}procesar_prenomina`, payload);
  return response;
};

const procesarPreNominaGlobal = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}procesar_prenomina/global`, payload);
  return response;
};

const cerrarPreNomina = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}procesar_prenomina/cerrar`, payload);
  return response;
};

const desafectarPreNomina = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}procesar_prenomina/desafectar`, payload);
  return response;
};

const recibosEncabezadoPreNomina = async (periodo_id, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}procesar_prenomina/headers?periodo_id=${periodo_id}&anio=${anio}&num_periodo=${num_periodo}`);
  return response;
};

const getDetallePreNomina = async (periodo_id, anio, num_periodo, odoo_empleado_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}procesar_prenomina/detalle?periodo_id=${periodo_id}&anio=${anio}&num_periodo=${num_periodo}&odoo_empleado_id=${odoo_empleado_id}`);
  return response;
};

const generarPDFRecibos = async (payload) => {
  const params = new URLSearchParams();

  params.append('periodo_id', payload.periodo_id);
  params.append('anio', payload.anio);
  params.append('num_periodo', payload.num_periodo);

  if (payload.horario_id !== undefined && payload.horario_id !== null) {
    params.append('horario_id', payload.horario_id);
  }
  if (payload.job_id !== undefined && payload.job_id !== null) {
    params.append('job_id', payload.job_id);
  }
  if (payload.departamento_id !== undefined && payload.departamento_id !== null) {
    params.append('departamento_id', payload.departamento_id);
  }
  if (payload.area_id !== undefined && payload.area_id !== null) {
    params.append('area_id', payload.area_id);
  }
  if (payload.supervisor_id !== undefined && payload.supervisor_id !== null) {
    params.append('supervisor_id', payload.supervisor_id);
  }
  if (payload.empleado_rango) {
    params.append('empleado_rango', payload.empleado_rango);
  }

  const url = `${process.env.REACT_APP_SERVER}procesar_prenomina/generar-pdf?${params.toString()}`;
  const filename = `recibos_prenomina_${payload.periodo_id}_${payload.anio}_${payload.num_periodo}.pdf`;

  const response = await downloadFile(url, filename);
  return response;
};

const generarPDFPrenominaPeriodo = async (payload) => {
  const params = new URLSearchParams();

  params.append('periodo_id', payload.periodo_id);
  params.append('anio', payload.anio);
  params.append('num_periodo', payload.num_periodo);

  if (payload.horario_id !== undefined && payload.horario_id !== null) {
    params.append('horario_id', payload.horario_id);
  }
  if (payload.job_id !== undefined && payload.job_id !== null) {
    params.append('job_id', payload.job_id);
  }
  if (payload.departamento_id !== undefined && payload.departamento_id !== null) {
    params.append('departamento_id', payload.departamento_id);
  }
  if (payload.area_id !== undefined && payload.area_id !== null) {
    params.append('area_id', payload.area_id);
  }
  if (payload.supervisor_id !== undefined && payload.supervisor_id !== null) {
    params.append('supervisor_id', payload.supervisor_id);
  }
  if (payload.empleado_rango) {
    params.append('empleado_rango', payload.empleado_rango);
  }

  const url = `${process.env.REACT_APP_SERVER}procesar_prenomina/generar-pdf-periodo?${params.toString()}`;
  const filename = `prenomina_periodo_${payload.periodo_id}_${payload.anio}_${payload.num_periodo}.pdf`;

  const response = await downloadFile(url, filename);
  return response;
};

const generarExcelPrenominaPeriodo = async (payload) => {
  const params = new URLSearchParams();

  params.append('periodo_id', payload.periodo_id);
  params.append('anio', payload.anio);
  params.append('num_periodo', payload.num_periodo);

  if (payload.horario_id !== undefined && payload.horario_id !== null) {
    params.append('horario_id', payload.horario_id);
  }
  if (payload.job_id !== undefined && payload.job_id !== null) {
    params.append('job_id', payload.job_id);
  }
  if (payload.departamento_id !== undefined && payload.departamento_id !== null) {
    params.append('departamento_id', payload.departamento_id);
  }
  if (payload.area_id !== undefined && payload.area_id !== null) {
    params.append('area_id', payload.area_id);
  }
  if (payload.supervisor_id !== undefined && payload.supervisor_id !== null) {
    params.append('supervisor_id', payload.supervisor_id);
  }
  if (payload.empleado_rango) {
    params.append('empleado_rango', payload.empleado_rango);
  }

  const url = `${process.env.REACT_APP_SERVER}procesar_prenomina/generar-excel-periodo?${params.toString()}`;
  const filename = `prenomina_periodo_${payload.periodo_id}_${payload.anio}_${payload.num_periodo}.xlsx`;

  const response = await downloadFile(url, filename);
  return response;
};

const generarExcelHorasAnalitica = async (payload) => {
  const params = new URLSearchParams();

  params.append('periodo_id', payload.periodo_id);
  params.append('anio', payload.anio);
  params.append('num_periodo', payload.num_periodo);

  if (payload.horario_id !== undefined && payload.horario_id !== null) {
    params.append('horario_id', payload.horario_id);
  }
  if (payload.job_id !== undefined && payload.job_id !== null) {
    params.append('job_id', payload.job_id);
  }
  if (payload.departamento_id !== undefined && payload.departamento_id !== null) {
    params.append('departamento_id', payload.departamento_id);
  }
  if (payload.area_id !== undefined && payload.area_id !== null) {
    params.append('area_id', payload.area_id);
  }
  if (payload.supervisor_id !== undefined && payload.supervisor_id !== null) {
    params.append('supervisor_id', payload.supervisor_id);
  }
  if (payload.empleado_rango) {
    params.append('empleado_rango', payload.empleado_rango);
  }

  const url = `${process.env.REACT_APP_SERVER}procesar_prenomina/generar-excel-horas-analitica?${params.toString()}`;
  const filename = `horas_analitica_${payload.periodo_id}_${payload.anio}_${payload.num_periodo}.xlsx`;

  const response = await downloadFile(url, filename);
  return response;
};

const generarExcelHorasExtrasAnalitica = async (payload) => {
  const params = new URLSearchParams();

  params.append('periodo_id', payload.periodo_id);
  params.append('anio', payload.anio);
  params.append('num_periodo', payload.num_periodo);

  if (payload.horario_id !== undefined && payload.horario_id !== null) {
    params.append('horario_id', payload.horario_id);
  }
  if (payload.job_id !== undefined && payload.job_id !== null) {
    params.append('job_id', payload.job_id);
  }
  if (payload.departamento_id !== undefined && payload.departamento_id !== null) {
    params.append('departamento_id', payload.departamento_id);
  }
  if (payload.area_id !== undefined && payload.area_id !== null) {
    params.append('area_id', payload.area_id);
  }
  if (payload.supervisor_id !== undefined && payload.supervisor_id !== null) {
    params.append('supervisor_id', payload.supervisor_id);
  }
  if (payload.empleado_rango) {
    params.append('empleado_rango', payload.empleado_rango);
  }

  const url = `${process.env.REACT_APP_SERVER}procesar_prenomina/generar-excel-horas-extras-analitica?${params.toString()}`;
  const filename = `horas_extras_analitica_${payload.periodo_id}_${payload.anio}_${payload.num_periodo}.xlsx`;

  const response = await downloadFile(url, filename);
  return response;
};

const getEncabezadoPreNomina = async (periodo_id, anio, num_periodo, odoo_empleado_id) => {
  const response = await get(
    `${process.env.REACT_APP_SERVER}procesar_prenomina/encabezado?periodo_id=${periodo_id}&anio=${anio}&num_periodo=${num_periodo}&odoo_empleado_id=${odoo_empleado_id}`
  );
  return response;
};

export { procesarPreNomina, procesarPreNominaGlobal, cerrarPreNomina, desafectarPreNomina, recibosEncabezadoPreNomina, getDetallePreNomina, generarPDFRecibos, generarPDFPrenominaPeriodo, generarExcelPrenominaPeriodo, generarExcelHorasAnalitica, generarExcelHorasExtrasAnalitica, getEncabezadoPreNomina };

